<template>
    <nav id="actions-top" class="wrap flex items-center flex-nowrap w-full">

        <router-link
            class="inline-flex items-center gap-2 whitespace-nowrap bg-primary text-white px-4 py-2 rounded-lg shadow-sm hover:shadow transition"
            :to="back">
            <i class="mask mask-arrow-left bg-white inline-block h-6 w-6 shrink-0"></i>
            <span>Retour</span>
        </router-link>

        <div class="ml-auto flex items-center gap-3">
            <slot></slot>
        </div>

    </nav>
</template>

<script>
export default {

    data() {
        return {

        }
    },

    props: {
        back: null
    },

    computed: {

    },

    methods: {

    }
}

</script>

<style>
#actions-top {
    display: flex;
    margin-bottom: 10px;
}

#actions-top a {
    cursor: pointer;
}

#main-action {
    flex-grow: 2;
    margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// ActionBar.vue?217e8202